import { useMemo } from 'react'
import DARK_PALETTE_TYPES from 'modules/Services/dark-palette'

export default function useNetworkPalette(type) {
  return useMemo(
    () =>
      !type ? '' : DARK_PALETTE_TYPES.indexOf(type) > -1 ? 'dark' : 'light',
    [type],
  )
}
